import {isPlatformCompatible, VirtualPackage} from '../../../types/packages/package';
import {Platform} from '../../../types/platform';
import {Component, Inject, OnInit} from '@angular/core';
import {DeviceService} from "../../../services/device/device.service";
import {WmNotificationService} from '../../notification/wm-notification.service';
import {convertBytesToSuitableUnitsString} from '../../../../shared/utils/utils'
import {LogoResolverService} from '@webmate-web-core/shared/services/logo-resolver.service';
import {AssetAndBlobService} from '@webmate-web-core/shared/services/assetAndBlob.service';
import {ProjectId} from '@webmate-web-core/shared/types/ids';
import {PackageService} from '@webmate-web-core/shared/services/package.service';
import {map, take} from 'rxjs/operators';
import {WebmateToolConfig} from '../../../tools/modaltoolcontainer/modaltoolcontainer.service';
import {TOOL_CONTAINER_DATA} from '../../../tools/modaltoolcontainer/modaltoolcontainer.component';
import {UntilDestroy, untilDestroyed} from '@ngneat/until-destroy';
import {AppVariantCallback} from '@webmate-web-core/shared/components/apps/split-view/app-split-view-details.component';


export class AppInstallationToolConfig implements WebmateToolConfig {
    toolName = "Install App";
    scrollable = true;

    constructor(public platform: Platform | undefined, public projectId: ProjectId, public triggeredAppInstallationCallback: (virtualPackage: VirtualPackage, instrumented: boolean) => void) {
    }
}

@UntilDestroy()
@Component({
    templateUrl: './app-installation.component.html',
    styleUrls: ['./app-installation.component.less']
})
export class AppInstallationComponent implements OnInit {

    private readonly platform?: Platform;
    private readonly triggeredAppInstallationCallback: (virtualPackage: VirtualPackage, instrumented: boolean) => void;

    readonly variantCallbacks = {
        regularActionName: 'Install on Device',
        regularCallback: (p: VirtualPackage) => {
            this.installAppOnDevice(p, false);
        },
        instrumentedActionName: 'Install on Device',
        instrumentedCallback: (p: VirtualPackage) => {
            this.installAppOnDevice(p, true);
        }
    } as AppVariantCallback;

    virtualPackages: Array<VirtualPackage>;

    loadingPackages = true;

    constructor(@Inject(TOOL_CONTAINER_DATA) private data: AppInstallationToolConfig, private platformLogoResolver: LogoResolverService,
                private blobService: AssetAndBlobService, private packageService: PackageService) {
        this.platform = data.platform;
        this.triggeredAppInstallationCallback = data.triggeredAppInstallationCallback;
    }

    ngOnInit() {
        this.packageService.getPackagesForProject(this.data.projectId).pipe(map(packages => packages.filter(pckg => {
            // Check if the platform (Android, iOS) matches and if the platform version of the device is equal or greater than the
            // package minimum required version.
            if (!this.platform) {
                return true;
            }
            return this.platform.platformType.toLowerCase() === pckg.platform.platformType.toLowerCase()
                && isPlatformCompatible(pckg, this.platform);
        }))).pipe(untilDestroyed(this)).subscribe(packages => {
            this.virtualPackages = packages;
            this.loadingPackages = false;
        });
    }

    installAppOnDevice(p: VirtualPackage, instrumented: boolean) {
        this.triggeredAppInstallationCallback(p, instrumented);
    }

}
